import { ProjectStatusIcon } from "~/components/icons/project-status"
import { FolderKanbanIcon } from "lucide-react"
import type { ReactNode } from "react"
import { IssueSetting } from "~/components/issueDetailsPage/IssueSetting"
import { api } from "~/trpc/react"

export function IssueProjectPicker({
	teamId,
	value,
	onChange,
	disabled,
	trigger,
	shape = "default",
	variant = "outline"
}: {
	teamId: string
	value: string | null
	onChange: (projectId: string | null) => void
	disabled?: boolean
	trigger?: ReactNode
	shape?: "default" | "pill"
	variant?: "outline" | "flat"
}) {
	const projects = api.projects.list.useQuery({ teamId }, { enabled: !!teamId })
	return (
		<IssueSetting<string | null>
			ariaLabel="Issue project"
			activeTeamId={teamId}
			shape={shape}
			value={value}
			onChange={onChange}
			trigger={trigger}
			disabled={disabled || projects.isLoading || !!projects.error}
			popoverSize="lg"
			withSearch
			showArrow={shape !== "pill" && variant !== "flat"}
			showBorder={variant !== "flat"}
			options={[
				{
					value: null,
					searchText: "No project",
					display: (
						<>
							<FolderKanbanIcon className="size-4 shrink-0 text-text-sub" />
							<span>No project</span>
						</>
					)
				},
				...(projects.data?.map((project) => ({
					value: project.id,
					searchText: project.name,
					display: (
						<div
							className="flex min-w-0 flex-1 items-center gap-2"
							title={project.name}
						>
							<ProjectStatusIcon
								status={project.status}
								className="size-4 shrink-0"
							/>
							<span className="truncate">{project.name}</span>
						</div>
					)
				})) ?? [])
			]}
		/>
	)
}
